const GetCurrentLang = () => {
  const pathname = window.location.pathname
  const lang = (pathname.includes('/en/')) ? 'en' : 'id'
  return lang
}

export default GetCurrentLang